import React from 'react';

const ConfusedGuyLookingAtHisLaptop = (props) => {
  return (
    <svg
      width="364"
      height="260"
      viewBox="0 0 364 260"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g opacity="0.4">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M363.843 171.202C358.595 112.56 77.0381 -0.624363 24.7683 54.9199C-27.5017 110.464 22.7494 214.706 132.288 241.4C241.827 268.094 369.09 229.844 363.843 171.202Z"
          fill="#F2F2F2"
        />
      </g>
      <path
        d="M256.681 37.6067L266.983 27.3005C268.716 25.5667 271.527 25.5667 273.261 27.3005L300.687 54.7376C302.351 56.4026 303.285 58.6596 303.285 61.0131V242.757"
        stroke="#CBCBCB"
        strokeWidth="8"
      />
      <path
        d="M317.711 242.202H288.305C287.386 242.202 286.641 242.947 286.641 243.866V244.421C286.641 245.34 287.386 246.086 288.305 246.086H317.711C318.63 246.086 319.375 245.34 319.375 244.421V243.866C319.375 242.947 318.63 242.202 317.711 242.202Z"
        fill="#AFB9C5"
      />
      <path
        d="M236.985 31.559C244.135 24.4086 255.727 24.4086 262.877 31.559C270.027 38.7089 270.027 50.3011 262.877 57.4515L251.893 68.4363L226 42.5437L236.985 31.559Z"
        fill="#C5CFD6"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M236.834 57.7413C243.984 64.8912 250.922 69.5461 252.331 68.1374C253.739 66.7293 249.085 59.7914 241.934 52.6415C234.784 45.4911 227.846 40.8367 226.438 42.2448C225.03 43.6535 229.685 50.5915 236.834 57.7413Z"
        fill="#F2F2F2"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M82.4124 118.093C83.9528 117.905 85.5969 117.972 87.0294 118.579C90.0755 119.872 90.9414 123.471 90.8996 126.396C90.8546 129.544 90.186 132.983 92.5795 135.52C93.6798 136.685 95.0484 137.578 96.1288 138.766C97.2832 140.035 98.1889 141.487 98.8596 143.046C100.091 145.91 100.695 149.279 99.5694 152.283C98.5779 154.929 96.0834 157.316 96.6224 160.324C97.1847 163.462 100.348 165.861 102.326 168.198C104.565 170.843 106.626 174.224 106.965 177.692C107.289 181.017 105.842 184.378 103.621 186.891C99.1843 191.913 92.515 194.374 85.7903 194.359C82.9351 194.352 79.7026 194.223 77.2386 192.689C76.4771 192.215 76.0754 191.683 75.6227 190.943C75.2168 190.28 74.6806 189.848 74.06 189.379C72.6965 188.348 71.7118 186.959 71.0834 185.404C68.6432 179.363 70.5936 171.891 74.0093 166.527C74.8187 165.256 75.4813 164.033 75.0881 162.519C74.6778 160.937 73.6694 159.511 72.7774 158.152C71.8959 156.809 70.8897 155.527 70.2008 154.075C69.4793 152.553 69.2761 150.96 69.4036 149.295C69.6432 146.167 70.9934 143.281 72.9051 140.766C74.7463 138.343 76.9082 136.024 76.913 132.85C76.9184 129.484 74.6688 126.491 75.6272 123.07C76.024 121.654 76.821 120.2 78.1055 119.351C79.3373 118.537 80.9637 118.27 82.4124 118.093Z"
        fill="#DDE3E9"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M81.4059 123.472C81.4348 123.02 81.9708 122.749 82.3928 122.867C82.9483 123.022 82.9376 123.541 82.9229 124.004C82.878 125.425 83.0837 126.806 83.4254 128.186C84.1355 131.053 85.4478 133.694 86.4875 136.449C87.5263 139.2 88.014 142.042 87.4046 144.954C86.8301 147.699 85.9275 150.373 85.3396 153.122C84.8214 155.545 84.27 158.101 85.0591 160.517C85.8185 162.844 87.4974 164.738 88.7064 166.84C91.209 171.192 92.3194 176.02 92.4678 180.988C92.5367 183.295 92.4747 185.623 91.9395 187.886C91.6314 189.189 91.2175 190.95 90.101 191.849C89.5861 192.264 88.7056 192.407 88.2723 191.793C87.8655 191.217 88.2224 190.325 88.3515 189.711C88.9108 187.053 89.0233 184.336 88.8894 181.637C88.7599 179.022 88.4509 176.412 87.6281 173.915C86.8643 171.598 85.704 169.516 84.3385 167.489C82.947 165.424 81.5004 163.353 80.9255 160.906C80.3413 158.42 80.8159 155.89 81.4505 153.451C82.1216 150.872 83.0006 148.367 83.9093 145.857C84.7949 143.412 85.1089 141.098 84.62 138.539C83.6542 133.484 81.0691 128.737 81.4059 123.472Z"
        fill="#C5CFD6"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M123.084 124.228C124.99 124.807 126.883 125.741 128.242 127.205C131.132 130.319 130.245 135.025 128.65 138.462C126.933 142.162 124.331 145.881 125.798 150.126C126.472 152.077 127.606 153.845 128.245 155.811C128.928 157.913 129.223 160.102 129.185 162.294C129.116 166.322 128.045 170.62 125.136 173.587C122.575 176.2 118.387 177.726 117.429 181.564C116.43 185.567 118.873 190.05 119.957 193.843C121.184 198.136 121.815 203.206 120.379 207.484C119.003 211.585 115.529 214.808 111.596 216.624C103.738 220.254 94.6141 219.695 86.7347 216.179C83.3894 214.686 79.666 212.852 77.587 209.756C76.9446 208.799 76.7546 207.96 76.6145 206.85C76.489 205.854 76.0882 205.066 75.6083 204.187C74.5539 202.259 74.1333 200.104 74.2183 197.938C74.5488 189.525 80.7861 181.702 87.6275 177.136C89.2486 176.054 90.6722 174.953 91.0116 172.957C91.3661 170.873 90.9371 168.662 90.6093 166.59C90.2855 164.543 89.7826 162.505 89.7422 160.428C89.7001 158.254 90.304 156.264 91.3336 154.361C93.2679 150.787 96.3772 148.076 99.949 146.095C103.389 144.188 107.151 142.57 108.834 138.818C110.619 134.842 109.562 130.132 112.495 126.584C113.709 125.116 115.412 123.811 117.368 123.475C119.243 123.153 121.291 123.684 123.084 124.228Z"
        fill="#DDE3E9"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M119.19 130.804C119.46 130.284 120.229 130.244 120.661 130.605C121.229 131.08 120.945 131.689 120.685 132.229C119.889 133.889 119.406 135.632 119.083 137.444C118.412 141.212 118.563 145.028 118.336 148.834C118.11 152.638 117.192 156.259 114.954 159.387C112.844 162.338 110.388 165.032 108.261 167.979C106.386 170.576 104.403 173.313 104.061 176.589C103.73 179.742 104.701 182.865 105.014 185.988C105.661 192.454 104.431 198.753 102.002 204.714C100.875 207.482 99.5828 210.207 97.7719 212.606C96.7294 213.988 95.3232 215.856 93.5465 216.336C92.7273 216.557 91.6226 216.266 91.4376 215.311C91.2637 214.415 92.1481 213.546 92.6207 212.887C94.667 210.032 96.2214 206.874 97.4784 203.607C98.6962 200.443 99.702 197.19 100.048 193.801C100.368 190.657 100.101 187.584 99.5664 184.468C99.0212 181.292 98.4139 178.082 99.0235 174.883C99.6424 171.632 101.522 168.885 103.541 166.33C105.677 163.627 108.017 161.121 110.394 158.626C112.71 156.194 114.289 153.619 115.057 150.332C116.576 143.838 116.039 136.863 119.19 130.804Z"
        fill="#C5CFD6"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M64.1551 148.113C67.3247 148.113 70.1113 149.793 72.0314 152.178C74.2791 154.968 74.7331 158.377 75.6458 161.703C76.1 163.358 76.8811 165.001 78.25 166.126C79.495 167.149 81.0757 167.354 82.566 167.854C85.5443 168.852 87.9494 171.258 88.8992 174.193C90.0579 177.774 88.8306 181.385 89.0419 185.014C89.2359 188.346 92.5217 190.425 95.1653 192.023C97.7721 193.598 100.12 195.073 100.906 198.142C101.738 201.397 102.018 205.03 100.864 208.245C98.9444 213.599 93.3256 215.956 87.8963 216.321C82.9691 216.653 76.7737 216.132 73.0734 212.556C70.8591 210.416 70.0573 207.422 70.1568 204.444C70.2186 202.592 70.5854 200.757 71.0597 198.968C71.3958 197.7 71.85 196.437 71.9794 195.126C72.3233 191.639 69.1005 190.969 66.3572 190.012C62.8712 188.795 60.4307 186.497 58.7337 183.295C57.1532 180.314 56.4902 176.967 57.4375 173.685C57.9214 172.009 58.7991 170.489 59.9893 169.195C60.5133 168.626 61.2517 168.151 61.7246 167.553C62.166 166.994 62.0699 166.271 61.9178 165.617C61.2144 162.595 59.023 160.093 58.2392 157.076C57.5317 154.354 57.9499 150.965 60.439 149.209C61.5145 148.45 62.8407 148.122 64.1551 148.113Z"
        fill="#C5CFD6"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M68.4741 155.986C71.8335 159.565 72.7467 164.42 73.0147 169.126C73.1648 171.765 73.0086 174.548 73.7838 177.108C74.4472 179.298 76.0023 180.973 77.6053 182.556C80.832 185.742 84.4305 188.981 85.3743 193.592C85.928 196.298 85.5543 199.093 86.3195 201.769C87.0152 204.202 88.2403 206.591 89.7303 208.645C90.93 210.3 92.493 211.566 93.8045 213.108C94.2046 213.579 94.7777 214.272 94.6126 214.936C94.4194 215.715 93.4281 215.961 92.7248 215.839C91.0851 215.554 89.7048 213.988 88.6327 212.849C87.0649 211.185 85.7326 209.395 84.6498 207.387C83.4477 205.157 82.4799 202.79 82.0663 200.288C81.6371 197.692 81.8507 194.987 80.8707 192.496C79.2216 188.304 75.2218 185.83 72.33 182.563C68.7269 178.492 69.2642 173.426 69.6333 168.418C69.836 165.666 70.0376 162.558 68.647 160.045C68.1162 159.086 66.9326 158.192 66.7044 157.102C66.4954 156.103 67.6363 155.094 68.4741 155.986Z"
        fill="#AFB9C5"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M72.0569 214.793C72.0569 235.258 75.3967 245.982 93.0285 245.982C110.66 245.982 114 235.258 114 214.793H72.0569Z"
        fill="#BAD1DE"
      />
      <path
        d="M232.03 174.436H190.795V240.727H232.03V174.436Z"
        fill="#B2B2B2"
      />
      <path
        d="M190.956 174.436H149.72V240.727H190.956V174.436Z"
        fill="#D1D1D1"
      />
      <path
        d="M169.352 94.0543L167.594 129.687L159.328 155.818H174.21L181.939 133.304L184.354 107.718L169.352 94.0543Z"
        fill="#BAD1DE"
      />
      <path
        d="M168.937 218.6L171.929 232.725L161.879 233.935L159.02 220.027L168.937 218.6Z"
        fill="#FFEDE1"
      />
      <path
        d="M172.533 231.452C172.278 230.691 171.473 230.419 170.922 230.909C169.849 231.874 167.917 233.057 165.058 232.771C162.093 232.472 160.979 230.705 160.55 229.427C160.322 228.761 159.691 228.421 159.127 228.706L141.133 237.869C140.046 238.427 139.187 239.46 138.758 240.752C138.355 241.962 139.16 243.267 140.288 243.24L171.379 242.369C172.6 242.342 173.539 241.119 173.432 239.705L172.922 232.771C172.908 232.662 172.895 232.54 172.855 232.431L172.533 231.452Z"
        fill="#102F56"
      />
      <path
        d="M168.762 150.298H145.427C145.427 150.298 131.217 149.496 130.371 161.31C129.526 173.124 151.21 206.923 154.605 224.977L174.116 223.346L160.067 174.253L195.009 174.457C197.599 174.47 200.175 174.09 202.617 173.233C209.421 170.84 219.807 167.414 214.144 148.435L168.762 150.298Z"
        fill="#102F56"
      />
      <path
        d="M186.77 218.653L191.52 235.538L181.469 236.748L176.853 220.08L186.77 218.653Z"
        fill="#FFEDE1"
      />
      <path
        d="M192.124 234.257C191.869 233.496 191.064 233.224 190.514 233.713C189.44 234.679 187.508 235.861 184.65 235.576C181.684 235.277 180.57 233.51 180.141 232.232C179.913 231.565 179.282 231.226 178.719 231.511L160.724 240.674C159.637 241.232 158.779 242.265 158.349 243.556C157.947 244.766 158.752 246.072 159.879 246.044L191.507 245.174C192.728 245.147 193.667 243.923 193.56 242.51L192.5 235.576C192.486 235.467 192.473 235.345 192.433 235.236L192.124 234.257Z"
        fill="#102F56"
      />
      <path
        d="M196.645 80.0448C197.169 80.5614 220.584 86.6113 220.584 86.6113L215.579 100.084L189.976 98.1265L196.645 80.0448Z"
        fill="#BAD1DE"
      />
      <path
        d="M186.985 83.2952C186.985 83.2952 171.728 88.9372 169.352 94.049C170.171 101.268 172.68 108.215 176.813 114.156C181.885 121.443 188.152 133.965 186.998 150.293H231.105C231.105 150.293 228.73 104.354 215.674 86.7212L186.985 83.2952Z"
        fill="#BAD1DE"
      />
      <path
        d="M191.989 90.5784C196.323 89.6811 199.114 85.3986 198.229 81.0073L195.639 68.1598L179.952 71.4089L182.542 84.2566C183.428 88.6478 187.655 91.4756 191.989 90.5784Z"
        fill="#FFEDE1"
      />
      <path
        d="M196.712 72.6525C196.712 72.6525 195.062 83.0664 187.064 83.6918C180.06 84.2356 180.73 73.9712 180.73 73.9712L196.712 72.6525Z"
        fill="#F4DED0"
      />
      <path
        d="M187.695 77.9806L189.077 77.6543C196.015 76.0229 200.335 69.0078 198.725 61.9926L196.9 53.985C195.29 46.9562 188.366 42.5786 181.442 44.21L180.06 44.5363C173.122 46.1677 168.802 53.1829 170.412 60.1981L172.237 68.2057C173.847 75.2344 180.771 79.6121 187.695 77.9806Z"
        fill="#FFEDE1"
      />
      <path
        d="M194.377 65.3271C194.055 65.8845 193.747 66.7274 193.639 68.0054C193.518 69.6232 192.713 71.1595 191.371 72.0567C187.52 74.6398 184.582 68.1005 178.892 69.2561C178.892 69.2561 176.665 69.596 176.222 72.1111C175.779 74.6126 172.679 70.235 171.995 67.244C171.311 64.2531 170.962 82.0492 184.971 80.5402C184.971 80.5402 192.042 80.3091 196.806 73.0084C197.329 72.2063 197.638 71.2682 197.665 70.303C197.705 68.8755 197.504 66.7138 196.162 65.164C195.692 64.593 194.753 64.6745 194.377 65.3271Z"
        fill="#102F56"
      />
      <path
        d="M194.391 61.2866C194.391 61.2866 188.339 59.2609 189.359 50.3016C189.359 50.3016 174.33 64.7126 163.193 54.1355C163.193 54.1355 168.171 52.7896 170.224 49.3364C173.968 43.0418 184.73 34.368 193.345 44.4013C193.345 44.4013 203.825 42.7563 200.819 59.1113L194.391 61.2866Z"
        fill="#102F56"
      />
      <path
        d="M194.391 61.2895C194.968 63.791 197.437 65.3545 199.906 64.7835C202.388 64.1989 203.918 61.6973 203.354 59.1958C202.777 56.6943 200.309 55.1308 197.84 55.7018C195.357 56.2864 193.814 58.788 194.391 61.2895Z"
        fill="#FFEDE1"
      />
      <path
        d="M186.743 90.082L193.224 90.2043L188.688 99.7209L183.791 90.5985L186.743 90.082Z"
        fill="#102F56"
      />
      <path
        d="M198.779 80.4678L190.433 90.3379L195.868 96.6597L205.865 82.7382C205.865 82.7382 203.302 78.5644 198.779 80.4678Z"
        fill="white"
      />
      <path
        d="M186.743 90.0839L181.939 95.5764L178.557 87.0114C178.557 87.0114 179.443 83.1639 182.207 83.8981L186.743 90.0839Z"
        fill="white"
      />
      <path
        d="M188.514 96.6471C188.514 96.6471 182.247 113.206 183.804 136.699L189.976 142.409L197.182 135.38L189.413 95.5731L188.514 96.6471Z"
        fill="#102F56"
      />
      <path
        d="M200.229 135.966L186.81 140.439L185.925 148.419L203.718 143.035L200.229 135.966Z"
        fill="#FFEDE1"
      />
      <path
        d="M188.81 145.718C188.81 150.381 185.079 154.174 180.463 154.174C175.86 154.174 172.117 150.395 172.117 145.718C172.117 141.055 175.847 137.262 180.463 137.262C185.066 137.262 188.81 141.041 188.81 145.718Z"
        fill="#FFEDE1"
      />
      <path
        d="M186.984 150.29H163.662C163.662 150.29 149.452 149.488 148.607 161.302C147.761 173.117 171.043 209.09 174.438 227.131L193.948 225.499L178.302 174.231L213.244 174.435C215.834 174.449 218.411 174.068 220.853 173.212C227.656 170.819 238.042 167.393 232.379 148.414L186.984 150.29Z"
        fill="#102F56"
      />
      <path
        d="M116.63 108.521H156.953C158.282 108.521 159.422 109.459 159.704 110.777L167.299 146.859C167.675 148.626 166.333 150.299 164.548 150.299H123.554C122.212 150.299 121.058 149.334 120.803 148.001L113.879 111.919C113.53 110.152 114.859 108.521 116.63 108.521Z"
        fill="#B2B2B2"
      />
      <path
        d="M114.309 108.521H154.618C155.947 108.521 157.088 109.459 157.369 110.777L164.964 146.859C165.34 148.626 164.012 150.299 162.213 150.299H121.233C119.891 150.299 118.737 149.334 118.482 148.001L111.558 111.919C111.209 110.152 112.537 108.521 114.309 108.521Z"
        fill="#D1D1D1"
      />
      <path
        d="M166.199 147.214H193.748C194.593 147.214 195.264 147.907 195.264 148.75C195.264 149.607 194.58 150.287 193.748 150.287H165.662L166.199 147.214Z"
        fill="#B2B2B2"
      />
      <path
        d="M139.268 128.463C139.268 130.923 137.309 132.908 134.88 132.908C132.451 132.908 130.492 130.91 130.492 128.463C130.492 126.002 132.464 124.017 134.88 124.017C137.309 124.017 139.268 126.002 139.268 128.463Z"
        fill="white"
      />
      <path
        d="M210.964 99.4447L225.697 123.549L190.433 136.301L195.264 146.878C195.264 146.878 225.416 143.452 239.988 132.073C241.33 131.026 242.001 129.327 241.773 127.628C241.089 122.19 238.163 108.989 225.697 90.2271C223.161 86.4068 218.116 85.2512 214.184 87.5624C210.091 89.9552 208.656 95.2573 210.964 99.4447Z"
        fill="#BAD1DE"
      />
      <path
        d="M199.812 132.909L225.697 123.555L212.748 102.36"
        stroke="#DDE8EE"
        strokeWidth="0.7599"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M182.287 124.921L175.914 107.873"
        stroke="#DDE8EE"
        strokeWidth="0.7599"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M200.229 146.163C200.229 146.163 220.035 143.648 230.018 137.857"
        stroke="#DDE8EE"
        strokeWidth="0.7599"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default ConfusedGuyLookingAtHisLaptop;
